import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from '../styles.styl';
import Icon from '../../../../Icon';
import SelectCustom from '../../../../SelectCustom';

function VideoSettings({ otPublisher, devices = [], formatMessage }) {
  const [disabled, setDisabled] = useState(false);
  const hasVideo = true;

  const iconName = hasVideo ? 'video' : 'video-on-error';

  const videoDevices = devices.map(device => ({
    value: device.deviceId,
    label: device.label,
  }));

  const getActiveVideoId = () => {
    try {
      return otPublisher.publisher.getVideoSource().deviceId;
    } catch (e) {
      return '';
    }
  };

  const handleSelectVideoSource = useCallback(async deviceId => {
    setDisabled(true);
    try {
      await otPublisher.changeVideoSource(deviceId);
    } finally {
      setDisabled(false);
    }
  }, []);

  return (
    <div className={cn(styles.row, styles.rowMb)}>
      <div className={cn(styles.row, 'mr1')}>
        <Icon name={iconName} size={32} className="mr1" />
        <div>
          <span className={styles.text}>
            {formatMessage({ id: 'virtualVisit.test.camera' })}
          </span>
        </div>
      </div>
      <SelectCustom
        disabled={disabled}
        value={getActiveVideoId()}
        options={videoDevices}
        onChange={({ value }) => handleSelectVideoSource(value)}
        needUpdateDefaultValue
        className={styles.select}
      />
    </div>
  );
}

VideoSettings.propTypes = {
  formatMessage: PropTypes.func,
  otPublisher: PropTypes.object.isRequired,
  publisher: PropTypes.object.isRequired,
  devices: PropTypes.array.isRequired,
};

export default VideoSettings;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MediaSettings/VideoSettings/index.jsx